import React, { useState, useEffect } from 'react';
import './App.css';

//Parts of the website
import { Landing } from './components/Sections/Landing';
import { Introduction } from './components/Sections/Introduction';
import { Viz } from './components/Sections/Viz';
import { Footer } from './components/Sections/Footer';


function App() {
  const [highContrast, setHighContrast] = useState(false);
  const [buttonText, setButtonText] = useState('Higher Contrast');

  const toggleContrast = () => {
    setHighContrast(prev => !prev);
  };

  useEffect(() => {
    if (highContrast) {
      document.body.classList.add("high-contrast");
      setButtonText('More Colours');
    } else {
      document.body.classList.remove("high-contrast");
      setButtonText('Higher Contrast');
    }
  }, [highContrast]);
  return (
    <>
      <button onClick={toggleContrast} id='highContrast'>
        {buttonText}
      </button>
      <Landing
        titleText1='Visualisation of Geothermal'
        titleText2='production Data'
        paragraphText='Access world geothermal energy production data and explore the latest data and trends by browsing global tables, maps and graphs.'
      />
      <Introduction />
      <Viz />
      <Footer />
    </>
  );
}

export default App;
